import React, { Component, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import Login from './views/Login'
import MainContext from './storage/MainContext'
import Register from './views/Register'
import PrivateRoute from './configs/PrivateRoute'
import { Toaster } from 'react-hot-toast'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

class App extends Component {
  render() {
    return (
      <MainContext>
        <>
          <BrowserRouter>
            <Suspense fallback={loading}>
              <Routes>
                <Route
                  path="*"
                  name="Home"
                  element={
                    <PrivateRoute>
                      <DefaultLayout />
                    </PrivateRoute>
                  }
                />
                <Route path="/login" name="login" element={<Login />} />
                <Route path="/register-admin" name="register" element={<Register />} />
              </Routes>
            </Suspense>
          </BrowserRouter>

          <Toaster />
        </>
      </MainContext>
    )
  }
}

export default App
